import { paginationResolver } from '@/core/resolvers/pagination.resolver'
import { IHttpClient } from '@/core/services/http'
import { PaginatedResponse } from '@/core/types/api/paginated-response'
import { ID } from '@/core/types/models/id.model'
import { cityResolver } from '../resolvers/city.resolver'
import { CityResponse } from '../types/api-responses/city-response'

type Params = {
  search?: string
  page?: number
  limit?: number
  isActive?: boolean
  countryId?: ID
}

export function createGetCitiesUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (
    {
      isActive = true,
      limit = 10,
      page = 1,
      search = '',
      countryId,
    }: Params = {},
    { controller }: { controller?: AbortController } = {},
  ) {
    const res = await httpClient
      .version('v1')
      .paginate(page, limit)
      .get<{ data: PaginatedResponse<CityResponse[]> }>(
        '/website/customer/cities',
        {
          params: {
            is_active: isActive ? '1' : '',
            search,
            country_id: countryId,
          },
          signal: controller?.signal,
        },
      )

    return {
      cities: cityResolver(res.data.data.data),
      pagination: paginationResolver(res.data.data.meta),
    }
  }
}
